import {del, get, getBlob, post} from 'api'

export function getEmployeeResumes(employeeId: number): Promise<any[]> {
  return get(`api/employees/resume/${employeeId}`);
}

export function uploadResume(employeeId: number, file: File, type: string, comment: string): Promise<any> {
  const formData = new FormData();
  formData.append("employeeId", String(employeeId));
  formData.append("file", file);
  formData.append("type", type);
  formData.append("comment", comment);
  return post(`api/employees/resume/upload/${employeeId}`, formData);
}

export function downloadEmployeeResume(id: number): Promise<Blob[]> {
  return getBlob(`api/employees/resume/download/${id}`);
}

export function deleteEmployeeResume(id: number) {
  return del(`api/employees/resume/${id}`);
}
